import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "edit-individual-modal__container edit-individual-modal__container--base-data" }
const _hoisted_2 = { class: "edit-individual-modal__container edit-individual-modal__container--amount" }
const _hoisted_3 = {
  key: 1,
  class: "edit-individual-modal__container edit-individual-modal__container--company"
}

import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import SingleSelectInput from '@/corePagesModule/SelectInput/SingleSelectInput.vue';
import { i18n } from '@/i18n';
import { useEditIndividualBusinessStore } from '../pages/useEditIndividualBusinessStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import TextInput from '@/unmanagedBusinessModule/components/TextInput.vue';
import { useForms } from '@/corePagesModule/composables/useForm';
import { FieldItem, ValidateRule } from '@/coreDomainsModule/constant/validateRules';
import {
  formOptionsAggregateBusiness,
  formOptionsBusiness,
  inputTypeKeyMap,
  keyMappingForSelectInput,
  validateRuleKeyMap,
  unitOptions,
  unitOptionsMapping,
} from '../constants';
import { ref, watch } from 'vue';
import { GetBusinessNameUseCase } from '@/coreUseCasesModule/getItem/GetBusinessNameUseCase';
import { GetBusinessNumberUseCase } from '@/coreUseCasesModule/getItem/GetBusinessNumberUseCase';
import { GetWarehouseNameUseCase } from '@/coreUseCasesModule/getItem/GetWarehouseNameUseCase';
import { GetWarehouseNumberUseCase } from '@/coreUseCasesModule/getItem/GetWarehouseNumberUseCase';
import { GetSupplierNameUseCase } from '@/coreUseCasesModule/getItem/GetSupplierNameUseCase';
import { GetSupplierNumberUseCase } from '@/coreUseCasesModule/getItem/GetSupplierNumberUseCase';
import { GetCustomerNameUseCase } from '@/coreUseCasesModule/getItem/GetCustomerNameUseCase';
import { GetCustomerNumberUseCase } from '@/coreUseCasesModule/getItem/GetCustomerNumberUseCase';
import { GetSalesDestinationNameUseCase } from '@/coreUseCasesModule/getItem/GetSalesDestinationNameUseCase';
import { GetSalesDestinationNumberUseCase } from '@/coreUseCasesModule/getItem/GetSalesDestinationNumberUseCase';
import { AggregateBusinessRepository } from '@/coreInfrastructureModule/Repositories/AggregateBusinessRepository';
import { BaseBusinessManageRepository } from '@/coreInfrastructureModule/Repositories/BaseBusinessManageRepository';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import AddOptionSection from '@/corePagesModule/updateBusinessModal/components/AddOptionSection.vue';
import { diContainer } from '@/coreContainer/container';
import { convertLeadTimeByUnit } from '@/coreDomainsModule/leadtime';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditIndividualBusinessModal',
  setup(__props) {

const t = i18n.t;
const store = useEditIndividualBusinessStore();
const { state } = storeToRefs(store);

const aggregateBusinessRepository = new AggregateBusinessRepository();
const baseBusinessManageRepository = new BaseBusinessManageRepository();

const fieldItems = computed((): FieldItem[] => {
  const targetArray = state.value.modalState.editState.type === 'aggregateBusiness' ? formOptionsAggregateBusiness : formOptionsBusiness;
  const items = targetArray.map((name: string) => {
    return {
      name,
      rules: validateRuleKeyMap[name],
    };
  });
  return items;
});

const { fieldState, allValidate, resetForm } = useForms(fieldItems.value);
const currentOpenSelectInputName = ref('');

/**
 * 編集モーダルの保存ボタン押下時の処理
 */
const editingModalOnNext = async () => {
  if (allValidate()) {
    if (isEditAggregateBusiness.value) {
      state.value.modalState.editState.item = BusinessFactory.create({
        ...state.value.modalState.editState.item,
        warehouseNumber: fieldState['warehouseNumber'].value.value,
        warehouse: fieldState['warehouseName'].value.value,
        supplierNumber: fieldState['supplierNumber'].value.value,
        supplierName: fieldState['supplierName'].value.value,
        businessNumber: fieldState['businessNumber'].value.value,
        businessName: fieldState['businessName'].value.value,
        package: fieldState['package'].value.value,
        unit: fieldState['unit'].value.value,
        manufacturer: fieldState['manufacturer'].value.value,
        leadTime: Number(fieldState['leadTime'].value.value) || 0,
        leadTimeUnit: store.convertDateUnit(fieldState['leadTimeUnit'].value.value),
        MOQ: Number(fieldState['MOQ'].value.value) || 0,
        stdInventoryIndices: {
          標準在庫指数: {
            max: Number(fieldState['stdInventoryIndicesMax'].value.value) || 0,
            min: Number(fieldState['stdInventoryIndicesMin'].value.value) || 0,
            option: {
              unit: store.convertDateUnit(fieldState['stdInventoryIndicesUnit'].value.value),
            },
          },
        },
      });
      state.value.modalState.isOpening.childBusinessList = true;
      state.value.modalState.isOpening.edit = false;
      await store.fetchChildBusiness();
    } else {
      state.value.modalState.editState.item = BusinessFactory.create({
        ...state.value.modalState.editState.item,
        customerNumber: fieldState['customerNumber'].value.value,
        customerName: fieldState['customerName'].value.value,
        salesDestinationNumber: fieldState['salesDestinationNumber'].value.value,
        salesDestinationName: fieldState['salesDestinationName'].value.value,
        endUser: fieldState['endUser'].value.value,
      });
      state.value.modalState.isOpening.loading = true;
      state.value.modalState.isOpening.edit = false;
      await store.putEditedBaseBusiness();
    }
  }
};

/**
 * フォームのリストを見た目上で分かれている部分で分割して取得する
 */
const getDividedFormOptions = computed(() => {
  return [formOptionsAggregateBusiness.slice(0, 9), formOptionsAggregateBusiness.slice(9)];
});

/**
 * 編集しているデータが集計かどうか
 */
const isEditAggregateBusiness = computed(() => {
  return state.value.modalState.editState.type === 'aggregateBusiness';
});

/**
 * モーダルを閉じる処理
 */
const closeEditModal = () => {
  state.value.modalState.isOpening.edit = false;
  if (!store.isModalShown()) {
    store.resetEditModalState();
  }
};

/**
 * モーダルを開いた際の処理
 */
watch(
  () => state.value.modalState.isOpening.edit,
  (newVal) => {
    if (newVal) {
      if (state.value.modalState.editState.type === 'aggregateBusiness') {
        const targetLeadTimeUnit = state.value.modalState.editState.item['leadTimeUnit'];
        const targetStdInventoryIndices = state.value.modalState.editState.item.stdInventoryIndices;
        resetForm(fieldItems.value);
        for (let i = 0; i < fieldItems.value.length; i++) {
          const keyName = fieldItems.value[i].name;
          switch (keyName) {
            case 'warehouseName':
              fieldState[keyName].setValue(state.value.modalState.editState.item['warehouse'], false);
              break;

            case 'leadTime':
              fieldState[keyName].setValue(
                convertLeadTimeByUnit(state.value.modalState.editState.item['leadTime'] ?? 0, targetLeadTimeUnit ?? '').toString()
              );
              break;

            case 'leadTimeUnit':
              fieldState[keyName].setValue(targetLeadTimeUnit ? t(unitOptionsMapping[targetLeadTimeUnit]) : '', false);
              break;

            case 'stdInventoryIndicesMin':
              fieldState[keyName].setValue(
                targetStdInventoryIndices?.標準在庫指数?.min ? targetStdInventoryIndices['標準在庫指数'].min.toString() : '',
                false
              );
              break;

            case 'stdInventoryIndicesMax':
              fieldState[keyName].setValue(
                targetStdInventoryIndices?.標準在庫指数?.max ? targetStdInventoryIndices['標準在庫指数'].max.toString() : '',
                false
              );
              break;

            case 'stdInventoryIndicesUnit':
              fieldState[keyName].setValue(
                targetStdInventoryIndices?.標準在庫指数?.option.unit
                  ? t(unitOptionsMapping[targetStdInventoryIndices['標準在庫指数'].option.unit])
                  : '',
                false
              );
              break;

            default:
              fieldState[keyName].setValue(state.value.modalState.editState.item[keyName], false);
          }
        }
      } else {
        resetForm(fieldItems.value);
        for (let i = 0; i < fieldItems.value.length; i++) {
          const keyName = fieldItems.value[i].name;
          fieldState[keyName].setValue(state.value.modalState.editState.item[keyName] ?? '', false);
        }
      }
    }
  }
);

/**
 * 新規選択肢追加ボタンを押した際の処理
 * @param type - 選択肢の種類
 * @param name - 名前
 * @param code - コード(Package, Manufacturer, EndUserはなし)
 */
const addNewOption = (type: string, name: string, code?: string) => {
  switch (type) {
    case 'package':
    case 'manufacturer':
    case 'endUser':
      fieldState[type].setValue(name);
      break;
    default:
      if (!code) {
        console.error('エラー:取引編集>新規選択肢追加:Codeなし');
        state.value.modalState.isOpening.commonError = true;
        return;
      }
      fieldState[type + 'Name'].setValue(name);
      fieldState[type + 'Number'].setValue(code);
  }
  state.value.modalState.editState.isEdited = true;
  return;
};

/**
 * フォームの値を変更した際の処理
 * @param option - フォームの種類
 * @param value - 値
 */
const updateValue = (option: string, value: string) => {
  state.value.modalState.editState.isEdited = true;
  fieldState[option].setValue(value);
  const keyMap = {
    businessNumber: setBusinessName,
    businessName: setBusinessNumber,
    warehouseNumber: setWarehouseName,
    warehouseName: setWarehouseNumber,
    supplierNumber: setSupplierName,
    supplierName: setSupplierNumber,
    customerNumber: setCustomerName,
    customerName: setCustomerNumber,
    salesDestinationNumber: setSalesDestinationName,
    salesDestinationName: setSalesDestinationNumber,
  };
  if (keyMap[option]) keyMap[option]();
};

/**
 * 汎用的な値設定関数
 * @param useCase - 使用するユースケース
 * @param sourceKey - 取得元のキー
 * @param targetKey - 設定先のキー
 */
const setFieldValue = async (useCase, sourceKey, targetKey) => {
  if (fieldState[sourceKey].value.value === '') return; // 空文字（選択を外す）なら何もしない

  const result: INetworkResult<string | undefined, IError> = await useCase.execute(fieldState[sourceKey].value.value);

  // マッチする値が存在しない場合は何もしない
  if (result.status.type === 'success' && result.status.data !== undefined) {
    fieldState[targetKey].setValue(result.status.data);
  }
};

/** 商品名を設定する */
const setBusinessName = () => setFieldValue(diContainer.getBusinessNameUseCase, 'businessNumber', 'businessName');
/** 商品番号を設定する */
const setBusinessNumber = () => setFieldValue(diContainer.getBusinessNumberUseCase, 'businessName', 'businessNumber');
/** 置き場名を設定する */
const setWarehouseName = () => setFieldValue(diContainer.getWarehouseNameUseCase, 'warehouseNumber', 'warehouseName');
/** 置き場番号を設定する */
const setWarehouseNumber = () => setFieldValue(diContainer.getWarehouseNumberUseCase, 'warehouseName', 'warehouseNumber');
/** 仕入先名を設定する */
const setSupplierName = () => setFieldValue(diContainer.getSupplierNameUseCase, 'supplierNumber', 'supplierName');
/** 仕入先番号を設定する */
const setSupplierNumber = () => setFieldValue(diContainer.getSupplierNumberUseCase, 'supplierName', 'supplierNumber');
/** 売り上げ先名を設定する */
const setCustomerName = () => setFieldValue(diContainer.getCustomerNameUseCase, 'customerNumber', 'customerName');
/** 売り上げ先番号を設定する */
const setCustomerNumber = () => setFieldValue(diContainer.getCustomerNumberUseCase, 'customerName', 'customerNumber');
/** 送り先名を設定する */
const setSalesDestinationName = () =>
  setFieldValue(diContainer.getSalesDestinationNameUseCase, 'salesDestinationNumber', 'salesDestinationName');
/** 送り先番号を設定する */
const setSalesDestinationNumber = () =>
  setFieldValue(diContainer.getSalesDestinationNumberUseCase, 'salesDestinationName', 'salesDestinationNumber');

/**
 * バリデーションにRequiredがある場合は*を返す
 * @param key - 入力項目のキー
 */
const getRequiredMark = (key: string | number) => {
  if (validateRuleKeyMap[key].includes(ValidateRule.Required)) {
    return '*';
  }
  return '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(state).modalState.isOpening.edit,
    "modal-width": 1300,
    "back-button-label": _unref(t)('キャンセル'),
    "next-button-label": _unref(t)('保存'),
    "is-disabled-next-button": !_unref(state).modalState.editState.isEdited,
    onOnBack: closeEditModal,
    onOnNext: editingModalOnNext
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('編集')), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('選択済の取引ファイルに対して、項目の内容を修正できます。')), 1)
    ]),
    default: _withCtx(() => [
      (isEditAggregateBusiness.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDividedFormOptions.value[0], (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: _normalizeClass(["edit-individual-modal__item", index < 4 ? 'edit-individual-modal__item--base-data--upper' : 'edit-individual-modal__item--base-data--lower'])
                }, [
                  (_unref(inputTypeKeyMap)[option] === 'select')
                    ? (_openBlock(), _createBlock(SingleSelectInput, {
                        key: 0,
                        index: index,
                        label: _unref(t)(option) + getRequiredMark(option),
                        "model-value": _unref(fieldState)[option].value.value,
                        placeholder: _unref(t)(option),
                        "filter-type": _unref(keyMappingForSelectInput)[option],
                        "is-error": _unref(fieldState)[option]?.isError.value,
                        "error-message": _unref(fieldState)[option]?.errorMessage.value,
                        "onClick:selectInput": () => (currentOpenSelectInputName.value = option),
                        "onUpdate:modelValue": (e) => updateValue(option, e)
                      }, null, 8, ["index", "label", "model-value", "placeholder", "filter-type", "is-error", "error-message", "onClick:selectInput", "onUpdate:modelValue"]))
                    : (_openBlock(), _createBlock(TextInput, {
                        key: 1,
                        "model-value": _unref(fieldState)[option].value.value,
                        label: _unref(t)(option) + getRequiredMark(option),
                        placeholder: _unref(t)(option),
                        "is-error": _unref(fieldState)[option].isError.value,
                        "error-message": _unref(fieldState)[option].errorMessage.value,
                        "onUpdate:modelValue": (e) => updateValue(option, e)
                      }, null, 8, ["model-value", "label", "placeholder", "is-error", "error-message", "onUpdate:modelValue"]))
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDividedFormOptions.value[1], (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: option,
                  class: "edit-individual-modal__item"
                }, [
                  (_unref(inputTypeKeyMap)[option] === 'select')
                    ? (_openBlock(), _createBlock(SingleSelectInput, {
                        key: 0,
                        index: index + 9,
                        label: _unref(t)(option) + getRequiredMark(option),
                        "model-value": _unref(fieldState)[option].value.value,
                        placeholder: _unref(t)(option),
                        "filter-type": _unref(keyMappingForSelectInput)[option],
                        "is-error": _unref(fieldState)[option]?.isError.value,
                        "error-message": _unref(fieldState)[option]?.errorMessage.value,
                        "onClick:selectInput": () => (currentOpenSelectInputName.value = option),
                        "onUpdate:modelValue": (e) => updateValue(option, e)
                      }, null, 8, ["index", "label", "model-value", "placeholder", "filter-type", "is-error", "error-message", "onClick:selectInput", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (_unref(inputTypeKeyMap)[option] === 'selectUnit')
                    ? (_openBlock(), _createBlock(SingleSelectInput, {
                        key: 1,
                        index: index + 9,
                        label: _unref(t)(option) + getRequiredMark(option),
                        "model-value": _unref(fieldState)[option].value.value,
                        placeholder: _unref(t)(option),
                        "filter-type": _unref(keyMappingForSelectInput)[option],
                        "is-error": _unref(fieldState)[option]?.isError.value,
                        "error-message": _unref(fieldState)[option]?.errorMessage.value,
                        "prop-options": _unref(unitOptions).map((o) => _unref(t)(o)),
                        "onClick:selectInput": () => (currentOpenSelectInputName.value = option),
                        "onUpdate:modelValue": (e) => updateValue(option, e)
                      }, null, 8, ["index", "label", "model-value", "placeholder", "filter-type", "is-error", "error-message", "prop-options", "onClick:selectInput", "onUpdate:modelValue"]))
                    : (_openBlock(), _createBlock(TextInput, {
                        key: 2,
                        "model-value": _unref(fieldState)[option].value.value,
                        label: _unref(t)(option) + getRequiredMark(option),
                        placeholder: _unref(t)(option),
                        "is-error": _unref(fieldState)[option].isError.value,
                        "error-message": _unref(fieldState)[option].errorMessage.value,
                        "onUpdate:modelValue": (e) => updateValue(option, e)
                      }, null, 8, ["model-value", "label", "placeholder", "is-error", "error-message", "onUpdate:modelValue"]))
                ]))
              }), 128))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formOptionsBusiness), (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option,
                class: "edit-individual-modal__item"
              }, [
                _createVNode(SingleSelectInput, {
                  index: index,
                  label: _unref(t)(option) + getRequiredMark(option),
                  "model-value": _unref(fieldState)[option].value.value,
                  placeholder: _unref(t)(option),
                  "filter-type": _unref(keyMappingForSelectInput)[option],
                  "is-error": _unref(fieldState)[option]?.isError.value,
                  "error-message": _unref(fieldState)[option]?.errorMessage.value,
                  "onClick:selectInput": () => (currentOpenSelectInputName.value = option),
                  "onUpdate:modelValue": (e) => updateValue(option, e)
                }, null, 8, ["index", "label", "model-value", "placeholder", "filter-type", "is-error", "error-message", "onClick:selectInput", "onUpdate:modelValue"])
              ]))
            }), 128))
          ])),
      _createVNode(AddOptionSection, {
        options: _unref(store).getAddableOptions(isEditAggregateBusiness.value),
        onSetOption: addNewOption
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modal-state", "back-button-label", "next-button-label", "is-disabled-next-button"]))
}
}

})